import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-[95%]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "font-bold pl-10 mt-10 mb-3" }, "Profile", -1)
const _hoisted_3 = { class: "flex flex-col pl-10 text-black bg-gray-300 hover:bg-primary-violet hover:bg-opacity-20 mx-3 my-2 py-2 rounded-base capitalize" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)

import { computed, onMounted } from "vue"
  import { useRouter } from "vue-router"
  import { useUserStore } from "@/store/user"
  import { useResourcesStore } from "@/store/resources"
  import { IonPage, IonButton } from "@ionic/vue"
  import { arrowBackCircle } from "ionicons/icons"

  import PersonalContainer from "@/components/talent-profile/PersonalContainer.vue"
  import ProfessionalContainer from "@/components/talent-profile/ProfessionalContainer.vue"
  import EmploymentContainer from "@/components/talent-profile/EmploymentStatus.vue"
  import UploadCvContainer from "@/components/talent-profile/UploadCV.vue"
  import ConnectionsContainer from "@/components/talent-profile/ConnectionsContainer.vue"

  // initialize stores
  
export default /*#__PURE__*/_defineComponent({
  __name: 'EditProfile',
  setup(__props) {

  const userStore = useUserStore()
  const resourceStore = useResourcesStore()

  const router = useRouter()

  const profile = computed<any>(() => userStore.customerDetails.profile)

  const choice = [
    {
      name: "personal details",
      component: PersonalContainer,
    },
    {
      name: "professional summary",
      component: ProfessionalContainer,
    },
    {
      name: "employment status display",
      component: EmploymentContainer,
    },
    {
      name: "upload CV",
      component: UploadCvContainer,
    },
    {
      name: "social accounts",
      component: ConnectionsContainer,
    },
  ]

  onMounted(async () => {
    await resourceStore.retrieveIndustries()
    await userStore.retrieveProfileDetails("details")
    await userStore.retrieveProfileDetails("bio")
    await userStore.retrieveProfileDetails("employment")
    await userStore.retrieveProfileDetails("cv")
    await userStore.retrieveProfileDetails("socials")
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_nav_link = _resolveComponent("ion-nav-link")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("h2", {
            class: "font-bold flex items-center gap-2",
            onClick: _cache[0] || (_cache[0] = () => _unref(router).back())
          }, [
            _createVNode(_component_ion_icon, {
              class: "text-3xl text-gray-300",
              icon: _unref(arrowBackCircle)
            }, null, 8, ["icon"]),
            _createTextVNode(" Edit profile")
          ]),
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(choice, (choices) => {
              return _createVNode(_component_ion_nav_link, {
                key: `${choices}_id`,
                "router-direction": "forward",
                component: choices.component
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(choices.name), 1)
                ]),
                _: 2
              }, 1032, ["component"])
            }), 64)),
            _hoisted_4,
            _createVNode(_unref(IonButton), {
              expand: "block",
              color: "white",
              class: "text-white bg-primary-violet font-bold rounded-[4px] shadow-base",
              onClick: _cache[1] || (_cache[1] = () => _unref(router).push(`/talent-profile/${_unref(profile).user_id}`))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Save and exit CV builder")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})